import {
  Box,
  Grid
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// import it from "date-fns/locale/it";
// import { newsXmlParsed } from "./news";
import { ChevronDown } from "lucide-react";
import {
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { useTranslation } from "react-i18next";
import { HeroBox } from "./Homepage.styles";
import {
  GridMain,
  Spinner,
  PreviewWidget, KeepLearningWidget, CardUserGoals
} from "../../components";
import { AgendaWidget } from "../../components/AgendaWidget";
import { useAnnouncement } from "../../components/Announcement/Announcement.component";
import { BigCarouselCardRestyled } from "../../components/BigCarouselCardRestyle/BigCarouselCardRestyle.component";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { CardGoals } from "../../components/CardGoals/CardGoals.component";
import { CardRanking } from "../../components/CardRanking/CardRanking.component";
import { CardUserCampaigns } from "../../components/CardUserCampaigns";
import { CarouselCardRestyle } from "../../components/CarouselCardRestyle/CarouselCardRestyle.component";
//import { FilterItem } from "../../components/FiltersBar/FiltersBar.types";
import { AttributeTabs } from "../../components/FilterTabs/AttributeTabs.component";
import { HeroCard } from "../../components/HeroCard/HeroCard.component";
import { HeroCardHomeVariants } from "../../components/HeroCard/HeroCard.variants";
import { HomeAlert } from "../../components/HomeAlert/HomeAlert.component";
import { UserProgressWidget } from "../../components/UserProgressWidget/UserProgressWidget";
import { WidgetDrawer } from "../../components/WidgetDrawer/WidgetDrawer.component";
import {
  CONTENTS_NAME,
  FILTERS,
  PAGE_NAME,
  STATUS_LO
} from "../../consts";
import { UserNavigationContext } from "../../context/UserNavigationContext";
import { useFontSizeObserver } from "../../hooks";
import {
  useInfiniteContentQuery,
  useSmartConfiguratorGenericQuery,
  useStructuresQuery,
  useTopicsQuery
} from "../../queries";
import { FilterDrawer } from "../../routes/Explore/FilterDrawer.component";
import { useAuthStore, useLanguageStore } from "../../stores";
import { useAttributeTabStore } from "../../stores/attributeTabStore";
import type {
  LearningObject,
  MetaData
} from "../../types";
import { createEndDate, createStartDate } from "../../utils/general";

// Utility function to map topicTagIds to translated topic names
function mapTopicIdsToNames(topicTagIds: number[] | undefined, allTopics: { id: number; name: string }[] | undefined): string[] {
  if (!topicTagIds || !allTopics) return [];

  return topicTagIds
    .map(id => allTopics.find(topic => topic.id === id)?.name)
    .filter(Boolean) as string[];
}

export function Homepage() {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { announce } = useAnnouncement();

  const { setNavigation } = useContext(UserNavigationContext);

  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  const smartConfiguration = useAuthStore(state => state.smartConfiguration);
  const language = useLanguageStore(state => state.language)?.id;

  const isLoading = useAuthStore(state => state.isLoading);
  const isAuthenticated = useAuthStore(state => Boolean(state.userData && state.userInfo));
  const isLoginComplete = !isLoading && isAuthenticated;
  //TODO:Quando sarnno implementati i parametri bisogna aggiungere al path lo state "filterQuery"
  // useEffect(() => {
  //   console.log({ filterQuery });
  // }, [filterQuery]);

  // const language = useLanguageStore(state => state.language)?.id;

  const [filterQuery, setFilterQuery] = useState("");
  /*
  const [filters, setFilters] = useState<FilterItem[]>([{
    icon: "Icons_obbligatorio",
    selected: false,
    value: "MANDATORY",
    value_active: "MANDATORY_ACTIVE",
    value_not_active: "MANDATORY_NOT_ACTIVE"
  },
  {
    icon: "AI",
    selected: false,
    value: "AI_SUGGESTED",
    value_active: "AI_SUGGESTED_ACTIVE",
    value_not_active: "AI_SUGGESTED_NOT_ACTIVE"

  },
  {
    icon: "Icons_invito",
    selected: false,
    value: "HR_SUGGESTED",
    value_active: "HR_SUGGESTED_ACTIVE",
    value_not_active: "HR_SUGGESTED_NOT_ACTIVE"

  },
  {
    icon: "manager_suggested",
    selected: false,
    value: "MANAGER_SUGGESTED",
    value_active: "MANAGER_SUGGESTED_ACTIVE",
    value_not_active: "MANAGER_SUGGESTED_NOT_ACTIVE"

  }
  ]);
*/
  const { hideWidgets } = useFontSizeObserver();
  const { setSelectedTab, resetAttribute, selectedTab } = useAttributeTabStore();
  const { data: smartConfigurationTexts } = useSmartConfiguratorGenericQuery({});
  const { data: pageStructureForYou } = useStructuresQuery({
    pageName: PAGE_NAME.FOR_YOU_OVERVIEW
  });
  const { data: allTopics } = useTopicsQuery({ available: true });

  const learningObjectsCounterRef = useRef<number>(0);

  // se è selezionato un attributo inserire il path attributeId,
  // se tutti o o mandatory il primo path

  const handlePath = (): string => {
    switch (selectedTab) {
    case FILTERS.ALL:
    case FILTERS.MANDATORY:
      return pageStructureForYou?.relativePaths?.[0]?.apiPath ? pageStructureForYou?.relativePaths?.[0]?.apiPath+"&"+filterQuery : ""; //"/learning-catalogue/{corporateId}/{initiativeId}/learnerMandatoryLearningObjects?overviewPageName=FOR_YOU_OVERVIEW_MANDATORY&pageNumber={pageNumber}&pageSize={pageSize}";
    default:
      return `/learning-catalogue/{corporateId}/{initiativeId}/attribute-learning-objects?attributeId=${selectedTab}&completed=false&pageSize={pageSize}&pageNumber={pageNumber}&${filterQuery}`;
    }
  };

  const {
    data: homeCards,
    hasNextPage: homeCardsHaveNextPage,
    isFetchingNextPage: homeCardsAreFetchingNextPage,
    fetchNextPage: homeCardsFetchNextPage,
    isLoading: isFetching
  } = useInfiniteContentQuery<
    & Record<string, LearningObject[]>
    & { metadata: MetaData }
  >({
    enabled: Boolean(pageStructureForYou?.relativePaths?.[0]?.apiPath),
    learningObjectsType: selectedTab === "mandatory" ?["MANDATORY"]:[],//LOGICA IN PROD :Array.from(learningObjectsTypes),
    pageSize: 12,
    path: handlePath(),// LOGICA IN PROD : pageStructureForYou?.relativePaths?.[0]?.apiPath?? ""
    language
    // topics: []
  });

  setSpinnerLoginVisible(false);

  const apiHomeCards = homeCards?.pages?.reduce((acc, page) => {
    let contents = page?.[CONTENTS_NAME.FOR_YOU] ?? [];
    if(page["corporateAttributeLearningObjects"]){
      contents = page["corporateAttributeLearningObjects"];
    }else if(page["mandatoryLearningObjects"]){
      contents = page["mandatoryLearningObjects"];
    }
    return acc.concat(contents);
  }, [] as LearningObject[]);

  useEffect(() => {
    setNavigation && setNavigation([]);
    setNavigation && setNavigation(["/"]);
  }, [location.pathname]);

  const bannerInfo = smartConfigurationTexts?.find((conf) => conf.key4 == "bannerText");

  function renderCard(card: LearningObject) {
    if (!isMobile) {
      return (
        <BigCarouselCardRestyled
          coverPublicURL={ card.coverPublicURL }
          videoPublicURL={ card.videoPublicURL }
          duration={ card.duration }
          id={ card.id }
          learningObjectTypology={ card.learningObjectTypology }
          shortDescription={ card.shortDescription }
          simple={ true }
          title={ card.title }
          canAccessNow={ card.canAccessNow }
          percentageOfCompletion={ card.percentageOfCompletion?.slice(0, -1) || "0" }
          learningObjectType={ card.learningObjectType }
          categories={ mapTopicIdsToNames(card.topicTagIds, allTopics) }
          isExpired={ card.isExpired }
          isMandatory={ card.isMandatory }
          expirationDate={ card.expirationDate }
          enrollType={ card.enrollType }
          status={ card.status || "N" }
          endDate={ createEndDate(card) }
          startDate={ createStartDate(card) }
          isToj={ card.isToj }
          isHighLightEdition={ card?.editions?.[0]?.isHighlightEdition ?? false }
          labelMoreInfo={ false }
          isLinkRelative={ card.isLinkRelative }
          isEditorial={ card.isEditorial }
          link={ card.link }
          attributes={ card.attributes }
          externalFileUrl={ card.externalFileUrl }
          isSuggestedAI={ card.isSuggestedAI }
          isSuggestedHR={ card.isSuggestedHR }
          isSuggestedManager={ card.isSuggestedManager }
          ecm_specialization={ card.ecm_specialization }
          ecmRegistration={ card.ecmRegistration }
          badge={ card.badge }
          certificate={ card.certificate }
          complexity={ card.complexity }
          isCarouselView={ false }
        />
      );
    }

    return (
      <CarouselCardRestyle
        canAccessNow={ card.canAccessNow }
        enrollType={ card.enrollType }
        booked={ card.status !== STATUS_LO.N && card.status !== STATUS_LO.T }
        categories={ mapTopicIdsToNames(card.topicTagIds, allTopics) }
        coverPublicURL={ card?.coverPublicURL?.toString() || "" }
        coverVideoPublicURL={ card.videoPublicURL }
        percentageOfCompletion={ card.percentageOfCompletion?.slice(0, -1) || "0" }
        disabled={ false }
        duration={ card.duration }
        ecm_specialization={ card.ecm_specialization }
        ecmRegistration={ card.ecmRegistration }
        ecmType={ card.ecmType }
        editionNumber={ card.editionNumber }
        endDate={ createEndDate(card) }
        expirationDate={ card.expirationDate }
        id={ card.id }
        isAutoSubscribeEnable={ card.isAutoSubscribeEnable }
        isFavourite={ card.isFavourite }
        isMandatory={ card.isMandatory }
        isSurvey={ card.isSurvey }
        isTest={ card.isTest }
        isToj={ card.isToj }
        key={ `for-you-card-${card.id}--${language}` }
        learningObjectType={ card.learningObjectType }
        learningObjectTypology={ card.learningObjectTypology }
        shortDescription={ card.shortDescription }
        startDate={ createStartDate(card) }
        status={ card.status || "N" }
        title={ card.title }
        isLinkRelative={ card.isLinkRelative }
        externalFileUrl={ card.externalFileUrl }
        link={ card.link }
        attributes={ card.attributes }
        complexity={ card.complexity }
        isCarouselView={ false }
      />
    );
  }

  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1440));
  const shouldHide = isSmallScreen || hideWidgets;
 
  useEffect(() => {
    announce( t("announcement_home_page"));
  }, []);

  return (
    <>
      { !!bannerInfo &&
        <HomeAlert HomeAlertText={ bannerInfo.value1 } />
      }
      <GridMain
        component="div"
        role="none" 
        padding={ !isMobile ? "0 2.5rem" : "0 1rem" }
        sx={ {
          flexFlow: "unset !important"
        } }
      >

        <Grid
          container
          item
          component="article"
          arial-label={ t("topic_list") }
          flexDirection="column"
          flexGrow={ 1 }
          sx={ {

            [theme.breakpoints.down("sm")]: {
              padding: "0"
              // width: "100%"
            }
          } }
        >
          <>
            <FilterDrawer
              paddingAdded={ true }
              onChange={ (q) => setFilterQuery(q.toString()) }
              nameKeyFilterStorage="for_you_filters"
              categoryHidden={ false }
            ></FilterDrawer>
            <AttributeTabs
              aria-label={ t("filter") }
              onClickHandler={ (filterValue) => {
                if (filterValue === "ALL") {
                  resetAttribute();
                  return;
                }
                setSelectedTab(filterValue);
              } }
            >
              { isFetching ?
                <Spinner alignSelf="center" padding={ !isMobile ? 4 : 0 } size={ 80 } thickness={ 3 } /> : (
                  <>
                    { apiHomeCards && apiHomeCards.length > 0 ? (
                      <div style={ {
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column"
                      } }>
                        {
                          apiHomeCards.map((card: LearningObject) => (
                            <Box
                              sx={ {
                                // marginTop: i !== 0 ? "1.5rem" : "0",
                                marginY: "1.5rem",
                                maxWidth: "100%"
                              } }
                              key={ `explore-hero--card-${card.id}` }
                            >
                              { renderCard(card) }
                            </Box>
                          ))
                        }
                        { (homeCardsHaveNextPage && !homeCardsAreFetchingNextPage) ? (
                          <ButtonDigited
                            disableRipple
                            disabled={ false }
                            //disabled={ !homeCardsHaveNextPage }
                            onClick={ () => {
                              // setArrayLoToShow(learningObjectsRef.current.slice(0, Math.min(learningObjectsCounterRef.current + 12, learningObjectsRef.current.length)));
                              learningObjectsCounterRef.current = learningObjectsCounterRef.current +12;
                              homeCardsFetchNextPage();
                              announce(t("announcement_load_more"));
                            } }
                            typology="primary"
                            sx={ {
                              marginLeft: "auto",
                              marginRight: "auto",
                              marginY: "1.5rem",
                              width: "fit-content"
                            } }
                          >
                            <>
                              { t("load_more") }
                              <ChevronDown
                                color={ theme.customColors.textPrimaryCta }
                                size="1.5rem"
                              />
                            </>
                          </ButtonDigited>
                        ) :
                          homeCardsAreFetchingNextPage &&
                            <Spinner alignSelf="center" padding={ 2 } size={ 100 } thickness={ 2 } />
                        }
                        {
                          isFetching &&
                            <Spinner alignSelf="center" padding={ 2 } size={ 100 } thickness={ 2 } />
                        }
                      </div>
                    ) : (
                      <HeroBox sx={ { alignItems: "center" } }>
                        <HeroCard { ...HeroCardHomeVariants } />
                      </HeroBox>
                    ) }
                  </>
                )
              }
            </AttributeTabs>
          </>
        </Grid>
        { shouldHide  ? (
          <WidgetDrawer />
        ) : (
          <Grid
            item
            tabIndex={ shouldHide ? -1 : 0 }
            component="aside"
            role="region" 
            aria-label={ t("widget_component_label") }
            flexDirection="column"
            gap={ 2 }
            display="flex"
            width="27rem"
            sx={ {
              padding: !isMobile ? theme.spacing(3.875, 0, 2, 2.5) : 0,

              "&#side-menu-clone": {
                borderColor: "transparent",

                "&:after": {
                  content: "''",
                  position: "absolute",
                  top: "20px",
                  left: "10px",
                  width: "100%",
                  height: "100%",
                  border: `1px solid ${theme.customColors.backgroundPrimaryCta}`,
                  boxShadow: `0px 0px 24px 0px ${theme.customColors.backgroundPrimaryCta}80`,
                  borderRadius: "8px"
                }
              }
            } }
            id="side-menu"
          >
            { smartConfiguration?.widgetEditorial && <PreviewWidget enabled={ isLoginComplete }/> }
            { smartConfiguration?.widgetCalendar && <AgendaWidget enabled={ isLoginComplete } /> }
            { smartConfiguration?.progressWidget && <UserProgressWidget enabled={ isLoginComplete }/> }
            { smartConfiguration?.widgetContinueLearning && <KeepLearningWidget enabled={ isLoginComplete } /> }
            <CardRanking isUserPage={ false } enabled={ isLoginComplete } />
            { /*{ smartConfiguration?.widgetLeaderboard && <CardRanking isUserPage={ false } /> }*/ }
            { smartConfiguration?.widgetBadge && <CardGoals enabled={ isLoginComplete } /> }
            { /* <NewsCard { ...NewsCardVariants.Default }/> */ }
            { smartConfiguration?.progressWidget && <CardUserGoals
              color={ theme.customColors.textWidget }
              isProfilePage={ false }
              enabled={ isLoginComplete }
            /> }
            <CardUserCampaigns enabled={ isLoginComplete } />
          </Grid>
        ) }
      </GridMain>
    </>
  );
}
